import { REGISTER_BROKER_NOTIFICATIONS_REQUEST, GET_REGISTER_BROKER_NOTIFICATIONS, REGISTER_BROKER_NOTIFICATIONS_REQUEST_FAILURE,
  GET_REGISTER_BROKER_NOTIFICATIONS_COUNT } from "../types";

const initialState = {
  brokerNotifications: [],
  brokerNotificationCount: 0,
  loading: false,
  error: null,
};

const registerBrokerNotificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_BROKER_NOTIFICATIONS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_REGISTER_BROKER_NOTIFICATIONS: {
      return {
        ...state,
        brokerNotifications: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_REGISTER_BROKER_NOTIFICATIONS_COUNT: {
      return {
        ...state,
        brokerNotificationCount: action.payload,
        loading: false,
        error: null
      }
    }
    case REGISTER_BROKER_NOTIFICATIONS_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default registerBrokerNotificationsReducer